import { render, staticRenderFns } from "./HomeBottomView.vue?vue&type=template&id=0566daf2&scoped=true&"
import script from "./HomeBottomView.vue?vue&type=script&lang=js&"
export * from "./HomeBottomView.vue?vue&type=script&lang=js&"
import style0 from "./HomeBottomView.vue?vue&type=style&index=0&id=0566daf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0566daf2",
  null
  
)

export default component.exports